{
    "sectionHeader": "Statistiques sur le temps d'abandon",
    "sectionPara": "Vous pouvez également ajuster spécifiquement le(s) seuil(s) de durée d'abandon, qui sont utilisés par les sept variantes de statistiques d'abandon de type \"Abandonné <= Xs\".",
    "target1Label": "Cible 1 :",
    "target1Placeholder": "60",
    "target2Label": "Cible 2 :",
    "target2Placeholder": "90",
    "target3Label": "Cible 3 :",
    "target3Placeholder": "120",
    "target4Label": "Cible 4 :",
    "target4Placeholder": "150",
    "target5Label": "Cible 5 :",
    "target5Placeholder": "180",
    "target6Label": "Cible 6 :",
    "target6Placeholder": "300",
    "targetUnits": "s",
    "resetAnswerTargetsButtonLabel": "Réinitialiser les intervalles abandonnés",
    "resetAnswerTargetsPrompt": "Êtes-vous sûr de vouloir réinitialiser les 6 paramètres de seuil d'abandon des appels entrants à leurs valeurs par défaut ?",
    "resetAnswerTargetsConfirm": "Confirmer",
    "resetAnswerTargetsCancel": "Annuler",
    "NAME": "AbandonedTimeStatisticLanguage"
}